<template>
  <div class="home-slider">
    <swiper
      :slides-per-view="1"
      :space-between="30"
      :breakpoints="{
        992: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
      }"
      :speed="500"
      :loop="false"
      :autoplay="false"
      :modules="modules"
    >
      <swiper-slide>
        <router-link
          :to="{ name: 'connect-internet' }"
          class="home-tiles-menu_link"
        >
          <home-slider-slide01 />
        </router-link>
      </swiper-slide>
      <swiper-slide class="d-none d-lg-block">
        <router-link
          :to="{ name: 'connect-internet' }"
          class="home-tiles-menu_link"
        >
          <home-slider-slide01 />
        </router-link>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import HomeSliderSlide01 from "@/components/home/HomeSliderSlide01.vue";

export default {
  name: "HomeSliderComponent",
  components: {
    Swiper,
    SwiperSlide,
    HomeSliderSlide01,
  },
  setup() {
    return {
      modules: [Autoplay],
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_mixins";
@import "@/styles/_variables";

.home-slider {
  width: 100%;
  margin-bottom: 20px;

  @media @md {
    margin-bottom: 25px;
  }

  @media @lg {
    margin-bottom: 30px;
  }
}
</style>
